export default function ({ store, redirect, app, route }) {
  if (store.state.auth.loggedIn === false) {
    app.$cookies.set("Redirect", route.fullPath);

    return redirect(app.i18nPath("/login"));
  }
}
